const rtf = () => new Intl.RelativeTimeFormat(document.documentElement.lang || 'en', { numeric: 'auto' });

export function timeAgo(iso?: string | null): string {
  if (!iso) return '—';
  const d = (new Date(iso).getTime() - Date.now()) / 1000;
  const a = Math.abs(d);
  if (a < 45) return rtf().format(Math.round(d), 'second');
  if (a < 3600) return rtf().format(Math.round(d / 60), 'minute');
  if (a < 86400) return rtf().format(Math.round(d / 3600), 'hour');
  if (a < 86400 * 30) return rtf().format(Math.round(d / 86400), 'day');
  return dateShort(iso);
}
export const dateShort = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleDateString(document.documentElement.lang || 'en', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';
export const dateTime = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleString(document.documentElement.lang || 'en', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';
export const timeOnly = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleTimeString(document.documentElement.lang || 'en', { hour: '2-digit', minute: '2-digit' }) : '';
export const num = (n?: number | null, digits = 0) =>
  n === undefined || n === null ? '—' : new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: digits }).format(n);
export const compact = (n?: number | null) =>
  n === undefined || n === null ? '—' : new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(n);
export const money = (cents?: number | null, currency = 'usd') =>
  cents === undefined || cents === null ? '—' : new Intl.NumberFormat('en', { style: 'currency', currency: currency.toUpperCase() }).format(cents / 100);
export const microsToUsd = (m?: number | null) =>
  m === undefined || m === null ? '—' : new Intl.NumberFormat('en', { style: 'currency', currency: 'USD', maximumFractionDigits: m < 10_000_000 ? 4 : 2 }).format(m / 1_000_000);
export const pct = (n?: number | null, digits = 0) => (n === undefined || n === null || Number.isNaN(n) ? '—' : `${(n * 100).toFixed(digits)}%`);
export const initials = (name?: string | null) =>
  (name || '?').split(/\s+/).filter(Boolean).slice(0, 2).map((s) => s[0]!.toUpperCase()).join('') || '?';
export const duration = (seconds?: number | null) => {
  if (seconds === undefined || seconds === null) return '—';
  if (seconds < 60) return `${Math.round(seconds)}s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)}m`;
  return `${(seconds / 3600).toFixed(1)}h`;
};
